import Sales from "@/components/master/sales/Sales.vue";
import SalesAdd from "@/components/master/sales/SalesAdd.vue";
import SalesDetail from "@/components/master/sales/SalesDetail.vue";
import SalesEdit from "@/components/master/sales/SalesEdit.vue";
import SalesUpload from "@/components/master/sales/SalesUpload.vue";

let routesSales = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "SalesIndex",
        component: Sales
      },
      {
        path: 'add',
        meta: {
          title: "Sales System",
        },
        name: "SalesAdd",
        component: SalesAdd
      },
    
      {
        path: 'edit/:id',
        meta: {
          title: "Sales System",
        },
        name: "SalesEdit",
        component: SalesEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Sales System",
        },
        name: "SalesDetail",
        component: SalesDetail
      },
    
      {
        path: 'upload',
        meta: {
          title: "Sales System",
        },
        name: "SalesUpload",
        component: SalesUpload
      },
  ]
  
  export default routesSales
  